import React from 'react';

import { CloudProvider, NativeResources } from '@ariksa/inventory-core';
import { Box, HStack } from '@chakra-ui/react';

import { PrimaryButton } from 'components/DataEntry';
import { addConditionButtonStyles } from 'containers/Jit/MaskingPolicies/Components/DataPolicyWizard/styles';
import { renderDataPolicyConditionLabel } from 'containers/Jit/MaskingPolicies/Components/DataPolicyWizard/utils';

interface Props {
  resourceType: Record<string, any>;
  account: Record<string, any>;
  onClickAddBucket: () => void;
}

export const TargetDataSourcesLabel = (props: Props) => {
  const { resourceType, account, onClickAddBucket } = props;
  return (
    <HStack justify="space-between">
      {renderDataPolicyConditionLabel(
        'FOR',
        'the following target data sources',
        true,
      )}

      {resourceType?.value === NativeResources.SimpleStorageService &&
        account?.data?.provider === CloudProvider.Aws && (
          <Box>
            <PrimaryButton
              {...addConditionButtonStyles}
              onClick={() => onClickAddBucket()}
            >
              + ADD
            </PrimaryButton>
          </Box>
        )}
    </HStack>
  );
};
